import { createReducer } from 'redux-starter-kit';
import { putChecklist, putChecklists } from './checklistsActions';

/**
 * A selector for the checklists loaded in the domain state.
 * This is a dict object: { checkListCde: checklist}
 * @param {state} state The redux state of the application.
 *
 * @example const checklist = selectChecklistMap(state)[yourCode]
 */
export const selectChecklistMap = state => state.via.domain.checklists;

// A dict object with a property key of: checkListCode and a property value of: checklist.
const initialChecklists = {
  // checkListCode: { /* checklist object */ }
  // checkListCode: { /* checklist object */ }
  // ...etc
};

const checklistsReducer = createReducer(initialChecklists, {
  // Insert/Replace all checklists.
  [putChecklists]: (state, action) => {
    const checklists = action.payload;

    return checklists.reduce((newState, checklist) => {
      newState[checklist.checkListCode] = checklist; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...initialChecklists });
  },

  // Insert/Replace a single checklist.
  [putChecklist]: (state, action) => {
    const checklist = action.payload;

    return {
      ...state,
      [checklist.checkListCode]: checklist,
    };
  },
});

export default checklistsReducer;
